import { toast, ToastOptions } from 'react-toastify';
import Alert from 'react-scale/catalog/components/Alert';

/* eslint-disable restrict-imports/restrict-imports */
import { Color } from '@material-ui/lab/Alert';
import { ToastProps } from 'react-toastify/dist/types';
import { makeStyles } from 'design-system/product/theme';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { Box, Theme } from '@material-ui/core';

const CustomCatalogAlert = ({
  severity,
  message,
  toastProps,
}: {
  severity: Color;
  message: string;
  toastProps?: ToastProps;
}) => {
  const classes = useStyles({ severity: severity! });
  return toastProps ? (
    <Box className={classes.wrapperContainer}>
      <Alert severity={severity}>{message}</Alert>
      <HighlightOffIcon onClick={toastProps.closeToast} className={classes.closeIcon} />
    </Box>
  ) : null;
};

const useStyles = makeStyles<{ severity: Color }>(theme => ({
  wrapperContainer: {
    position: 'relative',
  },
  closeIcon: ({ severity }) => ({
    color: getColorBySeverity(severity, theme),
    borderRadius: '50%',
    background: 'white',
    position: 'absolute',
    top: -9,
    right: -9,
  }),
}));

const alertToast = (message: string, severity: Color, customProps?: ToastOptions) => {
  return toast(<CustomCatalogAlert severity={severity} message={message} />, {
    autoClose: 4000,
    closeOnClick: false,
    style: { background: 'none', boxShadow: 'none' },
    closeButton: false,
    hideProgressBar: true,
    ...customProps,
  });
};

class CatalogAlert {
  static info(message: string, customProps: ToastOptions = {}) {
    alertToast(message, 'info', customProps);
  }
  static error(message: string, customProps: ToastOptions = {}) {
    alertToast(message, 'error', customProps);
  }
  static warning(message: string, customProps: ToastOptions = {}) {
    alertToast(message, 'warning', customProps);
  }
  static success(message: string, customProps: ToastOptions = {}) {
    alertToast(message, 'success', customProps);
  }
}
export default CatalogAlert;

function getColorBySeverity(severity: Color, theme: Theme): string {
  switch (severity) {
    case 'error':
      return theme.palette.error.main;
    case 'success':
      return theme.palette.success.main;
    case 'warning':
      return theme.palette.warning.main;
    default:
      // 'info'
      return theme.palette.primary.main;
  }
}
